import React from 'react';
import {
    Box,
    // Button,
    Avatar,
    Typography,
    CircularProgress,
    Tooltip,
    IconButton,
    Divider,
    Button,
    InputLabel,
    Paper,
} from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import LunchDiningIcon from '@mui/icons-material/LunchDining';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined';
import LocationCityOutlinedIcon from '@mui/icons-material/LocationCityOutlined';
import AirplanemodeActiveOutlinedIcon from '@mui/icons-material/AirplanemodeActiveOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import TimeToLeaveOutlinedIcon from '@mui/icons-material/TimeToLeaveOutlined';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import outfit from '../../assets/images/outfit.svg';
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
import Private_transport from '../../assets/Icons/private_transport.svg';
import { createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import CircleIcon from '@mui/icons-material/Circle';

const theme = createTheme();
const useStyles = makeStyles({

    info_block: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '10px',
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    paperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(1),
        backgroundColor: '#fff',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        // padding: theme.spacing(0.5),
        alignItems: 'center',
        minWidth: '100%',
        width: 'max-content',
    },
    moduledisplayName: {
        color: '#000000',
        fontWeight: '500',
        fontSize: '16px'
    },
    moduletypographyName: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '5px'
    }
});

const ProfileSections = (props) => {
    const classes = useStyles();
    const { data, index, getStatus } = props;

    const getModuleIcon = (moduleItem) => {
        let moduleIcon = null;
        switch (moduleItem) {
            case 'CombineRegistration':
            case 'AllStarRegistration':
            case 'DraftRegistration':
                moduleIcon = <NoteAltOutlinedIcon
                    sx={{
                        transform:
                            'rotate(60deg)',
                    }}
                    fontSize="small"
                />;
                break;
            case 'Hotel':
            case 'DraftHotel':
            case 'AllStarHotel':
                moduleIcon = <LocationCityOutlinedIcon fontSize="small" />;
                break;
            case 'FlightInfo':
            case 'DraftFlightInfo':
            case 'Transportation':
            case 'DraftTransportation':
            case 'CombineTransportation':
                moduleIcon = <AirplanemodeActiveOutlinedIcon fontSize="small" />;
                break;
            case 'Credential':
                moduleIcon = <GroupIcon fontSize="small" />;
                break;
            case 'LunchRoom':
                moduleIcon = <LunchDiningIcon fontSize="small" />;
                break;
            case 'GreenRoom':
                moduleIcon = <BadgeOutlinedIcon fontSize="small" />;
                break;
            case 'Outfit':
                moduleIcon = <Box
                    component="img"
                    alt={
                        'OutfitType'
                    }
                    src={
                        outfit
                    }
                    sx={{
                        height: '18px',
                    }}
                />;
                break;
            case 'VIP':
                moduleIcon = <EventOutlinedIcon fontSize="small" />;
                break;
            case 'Ticket':
                moduleIcon = <ConfirmationNumberOutlinedIcon fontSize="small" />;
                break;
            case 'SatNightTransport':
                moduleIcon = <TimeToLeaveOutlinedIcon fontSize="small" />
                break;
            case 'AllStarPrivateTransport':
                moduleIcon = <Box
                    component="img"
                    alt="Private Transport"
                    src={Private_transport}
                    className={
                        classes.iconWidth
                    }></Box>
                break;
            case 'SocialResponsibility':
                moduleIcon = <VolunteerActivismIcon fontSize="small" />;
                break;
            case 'AllStarTicket':
                moduleIcon = <LocalActivityIcon fontSize="small" />;
                break;
            default:
                moduleIcon = null;
                break;

        }
        return moduleIcon;
    }

    return (
        <>{
            data &&
            <Box
                key={index}
                sx={{
                    display: 'flex',
                    flexDirection: {
                        xs: 'column',
                        md: 'row',
                    },
                    justifyContent: 'space-between',

                }}
            // className={classes.paperContent}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        border: 'solid 1px #638CDB',
                        borderRadius: '4px',
                        boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.4)',
                        // marginBottom:'20px',
                        margin: '0px 10px 20px 10px',
                        background: 'linear-gradient(to bottom, #e4e4e4, #ffffff)',
                        width: '100%'

                    }}
                >
                    {/* <Avatar variant="circular">
    <ProfileInitial
        data={key}
        navigationScreen={'changeUser'}
        showOnlyInitial={true}
    />
</Avatar> */}

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: {
                                xs: 'column',
                                md: 'row',
                            },
                            alignItems: 'center',
                            justifyContent:
                                'start',
                            flexWrap: 'wrap',
                            // whiteSpace: 'nowrap',
                            width: {
                                sm: '240px',
                                md: '230px',
                                lg: '220px',
                            },
                            minWidth: {
                                sm: '240px',
                                md: '230px',
                                lg: '220px',
                            },
                            border: 0,
                            //borderRight: 2,
                            borderStyle: 'solid',
                            borderColor: '#a1a1a1',
                            // marginRight: 1,
                        }}
                    >
                        <Avatar
                            alt={data.firstName}
                            sx={{ mx: 1, width: 35, height: 35 }}
                            src={
                                data.picUrl
                                    ? data.picUrl
                                    : '/broken-image.jpg'
                            }
                        />
                        <Typography
                            sx={{
                                fontWeight: 700,
                                alignItems: 'center',
                                display: 'flex',
                                fontSize: '17px',
                                color: 'primary.main',
                                cursor: 'default',
                            }}>
                            {data.firstName.charAt(0).toUpperCase() + data.firstName.slice(1) +
                                ' ' +
                                data.lastName.charAt(0).toUpperCase() + data.lastName.slice(1)}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: {
                                xs: 'column',
                                md: 'row',
                            },
                            alignItems: 'center',
                            justifyContent:
                                'flex-end',
                            flexWrap: 'wrap',
                            // whiteSpace: 'nowrap',
                            width: '145px',
                            minWidth: '145px',
                            border: 0,
                            //borderRight: 2,
                            borderStyle: 'solid',
                            borderColor: '#a1a1a1',
                            marginRight: '20px',
                        }}
                    >
                        <Tooltip>
                            <IconButton
                                onClick={(e) =>
                                    props.handleOpen(
                                        e,
                                        index,
                                        data,
                                        props.roleType
                                    )
                                }>
                                <NotificationAddIcon
                                    sx={{
                                        m: 1,
                                    }}
                                />
                            </IconButton>
                        </Tooltip>
                        <Button
                            variant="contained"
                            sx={{
                                marginRight: '8px',
                                fontSize: '0.755rem',
                                color: 'white',
                                padding: '5px 5px'
                            }}
                            onClick={() =>
                                props.userImpersonate(data)}
                        >
                            Select
                        </Button>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        {/* <Box>
            <Button
                variant="contained"
                size="small"
                onClick={() =>
                    userImpersonate(data)
                }>
                Select
            </Button>
        </Box> */}
                        <Box
                            component="span"
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                width: '100%',
                                alignItems: 'center',
                                //overflowX:'scroll',
                                //scrollBehavior:'smooth'
                                flexWrap: 'wrap',
                                justifyContent: 'flex-start',
                                //whiteSpace:'nowrap'                                                       
                            }}
                        >
                            {(data.userRoleType !== 'EventAdmin' && data.userRoleType !== 'EventStaff'
                                && data.userType !== 'Admin') && data.modules && data.modules.length > 0 &&
                                data.modules.map(
                                    (
                                        module,
                                        moduleIndex
                                    ) => {
                                        // console.log("module.moduleName",module.moduleName);
                                        return (
                                            <Box key={moduleIndex}>
                                                {module.noAccess ===
                                                    1 ||
                                                    module.moduleName ===
                                                    null ? null : (
                                                    <Box
                                                        key={
                                                            moduleIndex
                                                        }
                                                        className={
                                                            classes.info_block
                                                        }>
                                                        {/* <Typography
                                            sx={{
                                                fontWeight: 400,
                                                alignItems:
                                                    'center',
                                                display:
                                                    'flex',
                                                fontSize: 15,
                                                color: 'primary.main',
                                                marginRight:
                                                    '5px',
                                            }}>
                                            {module.moduleName ===
                                                'Social Responsibility' ||
                                            module.moduleName ===
                                                'Content Circuit'
                                                ? null
                                                : module.moduleName}
                                        </Typography> */}
                                                        {(module.status !==
                                                            null &&
                                                            module.status !==
                                                            undefined &&
                                                            module.displayName ===
                                                            'Social Responsibility') ||
                                                            module.displayName ===
                                                            'Content Circuit' ? null
                                                            : (
                                                                <Box
                                                                    className={
                                                                        classes.moduletypographyName
                                                                    }
                                                                >
                                                                    <Tooltip
                                                                        title={
                                                                            module.displayName
                                                                        }>
                                                                        {getModuleIcon(module.moduleName)}
                                                                    </Tooltip>
                                                                    <InputLabel
                                                                        className={
                                                                            classes.moduledisplayName
                                                                        }>
                                                                        {
                                                                            module.displayName
                                                                        }
                                                                    </InputLabel>
                                                                    <CircleIcon
                                                                        fontSize="small"
                                                                        style={{
                                                                            color: getStatus(
                                                                                module.status
                                                                            ),
                                                                            marginRight: '30px',
                                                                        }}
                                                                    />
                                                                </Box>

                                                            )}
                                                    </Box>
                                                )}
                                            </Box>
                                        );
                                    }
                                )}
                        </Box>
                    </Box>
                </Box>
            </Box>
        }</>
    )
}

export default ProfileSections;